import { useLazyQuery } from "@apollo/client";
import { CHECK_FEATURE_ACCESS } from "../../GraphQL/user";

export const useInteractonInterceptor = () => {
  const [query] = useLazyQuery(CHECK_FEATURE_ACCESS);
  return query;
};
